export { default } from './ClickAwayListener';


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/esm/ClickAwayListener/index.js
// module id = 537
// module chunks = 2